import React from "react";
import { Container, Button, Row, Col } from "reactstrap";

function WhyAttend() {
  // const [isOpen, setIsOpen] = React.useState(false);

  // const toggle = i => setIsOpen(i);
  console.log(waContent);
  return (
    <div
      style={{
        backgroundColor: "transparent",
      }}
      className="section p-5"
      data-parallax={true}
    >
      <Container>
        <Row>
          <Col lg={12}>
            <h2 className="text-700 mb-4 text-white text-uppercase">Why Attend</h2>
            <h5 className="text-white text-400">
              Join us for an unparalleled opportunity to network and connect with over 150+ senior
              leaders from diverse industries. Our carefully curated agenda is designed to help you
              tackle your current business-critical challenges and drive your industry forward with
              innovative ideas and strategies. By attending our summit, you will gain access to
              valuable resources that are guaranteed to help you:
              <br />
              <br />
            </h5>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {waContent.map((data, index) => (
            <Col lg={6} key={index} className="stat-div border">
              <div className=" p-3" style={{ minHeight: "130px" }}>
                <h4 className="text-700 mt-0 text-white">{data.title}</h4>
                <br />
                <h5 className="text-400 mt-0 text-white">{data.description}</h5>
              </div>
            </Col>
          ))}
        </Row>
        <br />
        <br />
        <Row className="justify-content-center">
          <Button className="p-2 rounded-0" color="primary" size="lg" href="/register">
            <h5 className="m-0 text-400 text-white">Register Now</h5>
          </Button>
        </Row>
      </Container>
    </div>
  );
}
export default WhyAttend;

const waContent = [
  {
    title: "Forge Strategic Connections",
    description:
      "Engage directly with visionary leaders, regulators, innovators, and decision-makers. These aren’t just conversations—they’re catalysts for collaboration, partnerships, and growth across the Middle East’s expanding financial ecosystem.",
  },
  {
    title: "Build Powerful, Lasting Partnerships",
    description:
      "Finnovex offers a unique platform to align with fintech disruptors, technology enablers, and banking trailblazers. Whether it’s co-developing next-gen solutions or entering new markets, this summit sets the stage for future-defining alliances.",
  },
  {
    title: "Shape the Future of Finance in the GCC",
    description:
      "Your participation contributes to driving policy, strategy, and innovation across the region. Be part of the movement that’s propelling the Middle East toward decentralized, intelligent, and inclusive finance.",
  },
];
